import { Loader2 } from "lucide-react";

export const CenteredLoader = () => (
  <div className="flex flex-1 items-center justify-center">
    <Loader2 className="h-8 w-8 animate-spin text-blue-500" />
  </div>
);
